import {
  ColorTile,
  EnergyEfficiencyLabel,
  EnergyEfficiencyOverview,
  ProductAsset,
  ProductAssetsFields,
  ProductDatasheet,
  ProductInfoProductAssetType,
  ProductMobileImageAsset,
  ProductTestRatingAsset,
  ProductTestRatingFrontViewAsset,
  ProductVideoAsset
} from '@spa/components/ProductAssetTypes';
import { ProductAssetDimensions } from '@spa/generated/graphql/graphql';
import { ProductAssets } from '@spa/lib/graphql/products/findOneProductDetailedByCode';

const getProductAssetTypeForTags = (
  tags: Array<string>
): ProductInfoProductAssetType | undefined => {
  return Object.values(ProductInfoProductAssetType).find((assetType) =>
    tags.some((tag) => tag === assetType)
  );
};

const convertProductAssetsToProductFields = (assets: ProductAssets): ProductAssetsFields => {
  const productDataSheets: Array<ProductDatasheet> = [];
  let colorTile: ColorTile | null = null;
  let energyEfficiencyLabel: EnergyEfficiencyLabel | null = null;
  let energyEfficiencyOverview: EnergyEfficiencyOverview | null = null;
  let testRatingAsset: ProductTestRatingAsset | null = null;
  let testRatingFrontViewAsset: ProductTestRatingFrontViewAsset | null = null;
  const mobileImages: Array<ProductMobileImageAsset> = [];
  const productVideos: Array<ProductVideoAsset> = [];

  assets?.forEach((asset) => {
    if (asset) {
      const { id, name, description, tags } = asset;
      const { contentType, url, dimensions: sourceDimensions } = asset.sources[0];
      const targetType: ProductInfoProductAssetType | undefined = getProductAssetTypeForTags(tags);
      const baseAsset: ProductAsset = {
        contentType: contentType ?? '',
        description,
        id,
        name,
        source: url
      };
      const dimensions: ProductAssetDimensions | null =
        sourceDimensions === null
          ? null
          : { width: sourceDimensions.width, height: sourceDimensions.height };

      switch (targetType) {
        case ProductInfoProductAssetType.COLOR_TILE:
          colorTile = dimensions === null ? null : { ...baseAsset, dimensions, type: targetType };
          break;
        case ProductInfoProductAssetType.PRODUCT_DETAIL_DATASHEET:
        case ProductInfoProductAssetType.PRODUCT_DECLARATION_OF_CONFORMITY:
        case ProductInfoProductAssetType.ENERGY_EFFICIENCY_DATASHEET:
        case ProductInfoProductAssetType.PRODUCT_INSTRUCTION:
        case ProductInfoProductAssetType.PRODUCT_LABORATORY_ANALYSIS:
        case ProductInfoProductAssetType.PRODUCT_PACKAGE_INSERT:
        case ProductInfoProductAssetType.PRODUCT_READING_SAMPLE:
        case ProductInfoProductAssetType.PRODUCT_SAFETY_DATA_SHEET:
          productDataSheets.push({ ...baseAsset, type: targetType });
          break;
        case ProductInfoProductAssetType.ENERGY_EFFICIENCY_LABEL:
          energyEfficiencyLabel =
            dimensions === null ? null : { ...baseAsset, dimensions, type: targetType };
          break;
        case ProductInfoProductAssetType.ENERGY_EFFICIENCY_OVERVIEW:
          energyEfficiencyOverview = { ...baseAsset, dimensions, type: targetType };
          break;
        case ProductInfoProductAssetType.TEST_RATING:
          testRatingAsset = { ...baseAsset, type: targetType };
          break;
        case ProductInfoProductAssetType.TEST_RATING_FRONT_VIEW:
          testRatingFrontViewAsset = { ...baseAsset, dimensions, type: targetType };
          break;
        case ProductInfoProductAssetType.MOBILE_PICTURE:
          mobileImages.push({ ...baseAsset, dimensions, type: targetType });
          break;
        case ProductInfoProductAssetType.PRODUCT_VIDEO:
          productVideos.push({ ...baseAsset, type: targetType });
          break;
      }
    }
  });

  return {
    colorTile,
    energyEfficiencyLabel,
    energyEfficiencyOverview,
    productDataSheets,
    productVideos,
    testRatingAsset,
    testRatingFrontViewAsset,
    mobileImages
  };
};

export { convertProductAssetsToProductFields };
